import { render, staticRenderFns } from "./AxxessPriceModal.vue?vue&type=template&id=71ef67e4&"
import script from "./AxxessPriceModal.vue?vue&type=script&lang=js&"
export * from "./AxxessPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports